(function() {
'use strict';

angular
    .module('TR')
    .controller('Terminal', Terminal);

function Terminal($scope, searchUnitService, $location, $route) {
    const cm = this;

    searchUnitService.getTerminals().then(function(t) {
        cm.terminals = t;
    });

    cm.selected = {
        terminal: searchUnitService.getTerminal()
    };

    $scope.$on('radio-clicked', function() {
        searchUnitService.setTerminal(cm.selected.terminal);
        $location.path($route.current.area);
    });
}
})();
